import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
export class StorageService{
   
    public logoutSubject = new Subject();
    public logout:any = null;

    constructor(){
        this.setLogout("0");
    }

    // Test
    clear(){
        if (typeof window !== 'undefined') {
        window.sessionStorage.clear();
        
        }
        if (typeof localStorage !== 'undefined') {
            localStorage.clear();
            }
    }

    public setUserItem(payload: any) {
        if (typeof localStorage !== 'undefined') {
        localStorage.setItem('pers',payload);
        }
        

    }

    public setLogout(log: any) {
        if (typeof localStorage !== 'undefined') {
        localStorage.setItem('logout',log);
        }
        

    }

    
    public getLogout() {
        if (typeof localStorage !== 'undefined') {
        return localStorage.getItem('logout');
        }

    }

    public getUserItem(){
        if (typeof localStorage !== 'undefined') {
        return localStorage.getItem('pers');
        }
    }

    remove(label){
        if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(label);
        }
    }

    public setItem(label, item){
        if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(label,item);
        }
    }

    public getItem(label) {

        return new Promise((resolve) => {

            resolve(window.sessionStorage.getItem(label));
            
            });
    }
}